import { InvoicingSystemType } from 'models/tenant-config'
import {
    TEXT_AGRESSO_MIDT,
    TEXT_DUETT_FILE,
    TEXT_ERP_KOMTEK_FILE,
    TEXT_POWER_OFFICE,
    TEXT_TRIPLETEX,
    TEXT_VISMA_FILE,
} from 'utils/translations/keys'
import { tr } from 'utils/translations/translate'

export const isApiSystem = (invoiceSystem: InvoicingSystemType) =>
    invoiceSystem?.toString() === InvoicingSystemType[InvoicingSystemType.Visma] ||
    invoiceSystem?.toString() === InvoicingSystemType[InvoicingSystemType.Tripletex] ||
    invoiceSystem?.toString() === InvoicingSystemType[InvoicingSystemType.PowerOffice] ||
    invoiceSystem?.toString() === InvoicingSystemType[InvoicingSystemType.IsyPa]

export const getInvoicingSystemName = (invoiceSystem: InvoicingSystemType) =>
    invoiceSystemTypeNames.find((x) => x.value === invoiceSystem?.toString())?.label

export const invoiceSystemTypeNames = [
    {
        label: tr('TEXT_NONE'),
        value: InvoicingSystemType[InvoicingSystemType.None],
    },
    {
        label: tr('TEXT_ERP_VISMA'),
        value: InvoicingSystemType[InvoicingSystemType.Visma],
    },
    {
        label: tr('TEXT_ERP_ISYPA'),
        value: InvoicingSystemType[InvoicingSystemType.IsyPa],
    },
    {
        label: tr('TEXT_ERP_AZUREFILE_RINGERIKE'),
        value: InvoicingSystemType[InvoicingSystemType.AzureFileShareRingerike],
    },
    {
        label: tr('TEXT_ERP_AZUREFILE_BERGEN'),
        value: InvoicingSystemType[InvoicingSystemType.AzureFileShareBergen],
    },
    {
        label: tr('TEXT_ERP_AZUREFILE_ISYPA'),
        value: InvoicingSystemType[InvoicingSystemType.AzureFileShareIsyPa],
    },
    {
        label: tr(TEXT_ERP_KOMTEK_FILE),
        value: InvoicingSystemType[InvoicingSystemType.KomTekFile],
    },
    {
        label: tr(TEXT_VISMA_FILE),
        value: InvoicingSystemType[InvoicingSystemType.VismaFile],
    },
    {
        label: tr(TEXT_DUETT_FILE),
        value: InvoicingSystemType[InvoicingSystemType.DuettFile],
    },
    {
        label: tr(TEXT_AGRESSO_MIDT),
        value: InvoicingSystemType[InvoicingSystemType.Agresso],
    },
    {
        label: tr(TEXT_TRIPLETEX),
        value: InvoicingSystemType[InvoicingSystemType.Tripletex],
    },
    {
        label: tr(TEXT_POWER_OFFICE),
        value: InvoicingSystemType[InvoicingSystemType.PowerOffice],
    },
]
